import { I18n } from 'react-redux-i18n';

export default (company) => {
  const { name, maxExercises, maxSims, maxUsers } = company;

  const sanitized = {
    name: name && name.trim(),
    maxExercises: maxExercises && Number(maxExercises),
    maxSims: maxSims && Number(maxSims),
    maxUsers: maxUsers && Number(maxUsers),
  };

  const mandatoryFields = ['name', 'maxExercises', 'maxSims', 'maxUsers'];

  const err = {};

  mandatoryFields.forEach((field) => {
    if (sanitized[field] === '' || sanitized[field] === undefined) {
      err[field] = `${field} is mandatory.`;
    }
  });

  if (Object.keys(err).length) return err;

  if (sanitized.name.length < 4 || sanitized.length > 50) {
    err.name = I18n.t('validations.nameLength');
  }


  if (sanitized.maxExercises < 0) {
    err.maxExercises = I18n.t('validations.maxExercisesGrtZero');
  }

  if (sanitized.maxSims < 1) {
    err.maxSims = I18n.t('validations.maxSimsGrtZero');
  }

  if (sanitized.maxUsers < 0) {
    err.maxUsers = I18n.t('validations.maxUsersGrtZero');
  }

  return err;
};
